import { ExclamationTriangleIcon } from "@vericus/cadmus-icons";
import { colors, Text } from "@vericus/cadmus-ui";

import { CANT_HEAR_FIXES, CANT_HEAR_TITLE } from "@/lib/microphone-copy";

import * as styles from "./silent-audio-nudge.css";

export function SilentAudioNudge() {
  return (
    <div className={styles.container}>
      <div className={styles.bubble}>
        <ExclamationTriangleIcon label="" size={16} color={colors.orange500} />
        <div>
          <Text kind="bodySm" bold>
            {CANT_HEAR_TITLE}
          </Text>
          <Text kind="bodySm">{CANT_HEAR_FIXES}</Text>
        </div>
      </div>
      <div className={styles.arrow} />
    </div>
  );
}
